module.exports = __webpack_public_path__ + "img/sx_02.6acc326c.jpg";